import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { RegionService } from './region.service';
import { Settings } from '../model/settings';
import { Region } from '../model/region';
import { StorageResult } from './init.service';
import { firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private static STORAGE_KEY = 'settings';
  public settings: Settings;
  public fromStorage: StorageResult

  constructor(
    private storage: StorageMap,
    private regionService: RegionService,
  ) {
    this.settings = new Settings();
    this.settings.regions = [];
    this.settings.smartRegion = true;
    this.settings.colorPalletIndex = 0;
    this.settings.language = 'en';
    this.settings.dataFetchInterval = 3 * 60 * 1000;
    this.settings.baseMapEffect = 'none';
    this.settings.baseMap = 'base';
    this.settings.dateType = 'relative';
    this.settings.animateHowMany = 5;
    this.settings.tablePosition = Settings.tableLocations[0].class;
    this.settings.cycleTablePosition = false;
    this.settings.source = 'iris';
  }

  public init(res: StorageResult): void {
    this.fromStorage = res;
    this.settings.regions = this.regionService.regions;
    if (res.settings) {
      // Old settings
      if (typeof (res.settings) == 'string') {
        try {
          res.settings = JSON.parse(res.settings);
        } catch (error) {
          console.log('Failed to parse settings');
          this.fromStorage.settings = this.settings;
          res.settings = this.settings;
        }
      }
      const rr = res.settings.regions;
      delete res.settings.regions;
      Object.assign(this.settings, res.settings);
      res.settings.regions = rr;
      this.syncToRegionService(res.settings.regions);
    } else {
      this.syncToRegionService();
    }
  }

  private syncToRegionService(storedRegions: Region[] = this.settings.regions) {
    this.regionService.regions.forEach((region: Region, index: number) => {
      const storedRegionSettingsIndex = storedRegions.findIndex((storedRegion: Region) => region.name === storedRegion.name);
      if (storedRegionSettingsIndex !== -1) {
        const storedRegion = storedRegions[storedRegionSettingsIndex];
        region.hideRegion = storedRegion.hideRegion;
        region.minMagnitudeToShow = storedRegion.minMagnitudeToShow;
        region.slideDuration = storedRegion.slideDuration;
      }
    });
    this.settings.regions = this.regionService.regions;
  }

  public async save(): Promise<void> {
    this.syncToRegionService();

    const store = JSON.parse(JSON.stringify(this.settings));
    store.regions.forEach((region: Region) => {
      region.image = undefined;
      region.events = [];
      region.asset = undefined;
    });
    await firstValueFrom(this.storage.set(SettingsService.STORAGE_KEY, store));
    console.log('Stored events')
  }

  public get() {
    return this.settings;
  }

}
